export default function VoucherCardSkeleton() {
  return (
    <div className="rounded-xl border border-white/[0.04] bg-gray-4 overflow-hidden flex flex-col">
      <div className="w-full aspect-[4/3] skeleton" />
      <div className="p-2.5 flex flex-col gap-2">
        <div className="w-4/5 h-3.5 skeleton rounded" />
        <div className="w-2/3 h-3 skeleton rounded" />
        <div className="flex justify-between items-center mt-1">
          <div className="w-12 h-4 skeleton rounded" />
          <div className="w-[60px] h-6 skeleton rounded-full" />
        </div>
      </div>
    </div>
  );
}
